import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../axiosInstance";
import exportToExcel from "../../utils/ExportToExcel";

const EventRegistrationReport = () => {
  const getEventRegistration = () => {
    return axiosInstance.get(`/reports/event-registrations`);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchTemples = async () => {
      try {
        const response = await getEventRegistration();
        setData(response.data);
      } catch (error) {
        console.error("Error fetching Event Registration data:", error);
      }
    };
    fetchTemples();
  }, []);

  const HumanReadableDate = ({ isoDate }) => {
    const date = new Date(isoDate);

    const humanReadableDate = date.toLocaleString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

    return <span>{humanReadableDate}</span>;
  };

  return (
    <>
      <section className="reports-banner">
        <div className="container mt-5 mb-5">
          <h1 className="mb-3 txt1" style={{ textAlign: "center" }}>
            Event Registration Report
          </h1>
          <div className="d-flex justify-content-end my-2">
            {data.length > 0 && <button
              className="btn btn-dark"
              onClick={() => exportToExcel(data, "Events Registration")}
            >
              Export to Excel
            </button>}
          </div>
          <div className="row bg-light font-weight-bold border p-2 d-none d-md-flex">
            <div className="col-md-1">ID</div>
            <div className="col-md-2">First Name</div>
            <div className="col-md-2">Last Name</div>
            <div className="col-md-2">Contact</div>
            <div className="col-md-2">Email</div>
            <div className="col-md-1">Occupation</div>
            <div className="col-md-2">Created At</div>
          </div>
          {data.map((item) => (
            <div className="row border p-2">
              <div className="col-12 col-md-1 text-wrap-column">
                <strong className="laptop-display-none">ID: </strong>
                {item.id}
              </div>
              <div className="col-12 col-md-2 text-wrap-column">
                <strong className="laptop-display-none">First Name: </strong>
                {item.first_name}
              </div>
              <div className="col-12 col-md-2 text-wrap-column">
                <strong className="laptop-display-none">Last Name: </strong>
                {item.last_name}
              </div>
              <div className="col-12 col-md-2 text-wrap-column">
                <strong className="laptop-display-none">Contact: </strong>
                {item.country_code}-{item.contact}
              </div>
              <div className="col-12 col-md-2 text-wrap-column">
                <strong className="laptop-display-none">Email:</strong>{" "}
                {item.email}
              </div>
              <div className="col-12 col-md-1 text-wrap-column">
                <strong className="laptop-display-none">Occupation: </strong>
                {item.occupation}
              </div>
              <div className="col-12 col-md-2 text-wrap-column">
                <strong className="laptop-display-none">Created At:</strong>{" "}
                <HumanReadableDate isoDate={item.created_at} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default EventRegistrationReport;
